import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@nike/podium';
import { MiniCardBase } from './MiniCardBase';
export function ExpressionMiniCard({ variant, isFirst = false }) {
    return (_jsx(MiniCardBase, { title: variant.name, subtitle: variant.subtitle, meta: _jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: variant.units }), imageSrc: variant.imagePath, imageAlt: variant.name, isFirst: isFirst }));
}
